<template>
  <el-main v-if="isStandaloneLayout" class="crmeb-layout-fullscreen">
    <router-view />
  </el-main>
  <layout-columns v-else-if="themeConfig.layout === 'columns'" />
  <layout-classic v-else-if="themeConfig.layout === 'classic'" />
  <layout-transverse v-else-if="themeConfig.layout === 'transverse'" />
  <layout-defaults v-else />
  <layout-settings-drawer />
</template>

<script setup lang="ts">
import { computed, onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';
import useCrmebThemeConfigStore from '@/store/modules/themeConfig';
import useCrmebMenuStore from '@/store/modules/menu';
import LayoutDefaults from './main/defaults.vue';
import LayoutColumns from './main/columns.vue';
import LayoutClassic from './main/classic.vue';
import LayoutTransverse from './main/transverse.vue';
import LayoutSettingsDrawer from './navBars/LayoutSettingsDrawer.vue';
import { isCrmebStandaloneRoute } from '@/config/crmeb-standalone-routes';

const route = useRoute();
const themeStore = useCrmebThemeConfigStore();
const crmebMenu = useCrmebMenuStore();

const themeConfig = computed(() => themeStore.themeConfig);

/** meta.fullScreen 或店铺装修等独立页（对齐 EB standalonePage） */
const isStandaloneLayout = computed(
  () => Boolean(route.meta?.fullScreen) || isCrmebStandaloneRoute(route.name),
);

function onLayoutResize() {
  const clientWidth = document.body.clientWidth;
  if (clientWidth < 1000) {
    themeStore.setCollapse(false);
  }
}

onMounted(() => {
  themeStore.initTheme();
  window.addEventListener('resize', onLayoutResize);
  onLayoutResize();
  if (route.path) {
    crmebMenu.syncLayoutByRoute(route);
  }
});

watch(
  () => route.path,
  () => {
    crmebMenu.syncLayoutByRoute(route);
  },
);
</script>

<style scoped>
.crmeb-layout-fullscreen {
  padding: 0 !important;
  height: 100%;
}
</style>
